import { render, staticRenderFns } from "./EligibilityCard.vue?vue&type=template&id=09668195&scoped=true&"
import script from "./EligibilityCard.vue?vue&type=script&lang=js&"
export * from "./EligibilityCard.vue?vue&type=script&lang=js&"
import style0 from "./EligibilityCard.vue?vue&type=style&index=0&id=09668195&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09668195",
  null
  
)

export default component.exports